<div class="chats-list" [class.dialog-mode]="chatMode === chatModes.DIALOG">
  <ng-scrollbar class="chats-scrollbar" [class.has-scroll]="scrollbarRef?.adapter?.isVerticallyScrollable?.()" (scroll)="onScroll($event)">
    @if (hasChannels && chatListInitialized) {
      <div class="chats-container">
        @for (item of channels; track item?.url) {
          <div
            class="chat-item"
            [class.active]="item === activeChannel"
            (click)="setActiveChannel(item)"
            >
            <app-chat-channel-image [channel]="item"></app-chat-channel-image>
            <div class="chat-item-info">
              <span
                ellipsis
                class="chat-item-title ellipsis"
                [textContent]="item.name">
              </span>
              @if (item.lastMessage; as lastMessage) {
                <div class="chat-item-message">
                  <span
                    ellipsis
                    class="message-text ellipsis"
                    [textContent]="lastMessage | chatLastMessage | async">
                  </span>
                  @if (item.unreadMessageCount) {
                    <span class="message-new-indicator">
                      {{ 'CHAT.new' | translate }}
                    </span>
                  }
                  @if (item.lastMessage?.createdAt | dateDiff; as date) {
                    <span class="message-date">{{date}}</span>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    } @else {
      @if (!isLoading) {
        @if (chatMode === chatModes.DIALOG) {
          <app-list-empty-state
            icon="chat-dots"
            [title]="'CHAT.no_group_chats_yet' | translate"
            [text]="'CHAT.group_chats_will_show_here' | translate">
          </app-list-empty-state>
        }
      } @else {
        <div class="chats-container">
          @for (item of placeholders; track $index) {
            <div class="chat-item">
              <lib-skeleton-loader height="32px" width="32px" className="circle"></lib-skeleton-loader>
              <div class="chat-item-info">
                <lib-skeleton-loader height="20px" width="60%"></lib-skeleton-loader>
                <lib-skeleton-loader height="16px" width="80%"></lib-skeleton-loader>
              </div>
            </div>
          }
        </div>
      }
    }
  </ng-scrollbar>



</div>
